import React from 'react';
import Layout from '../../components/Layout';
import 'bootswatch/dist/lux/bootstrap.css';
import ProductsGrid from './ProductsGrid';
import { Link } from "react-router-dom";


const Store = () => {
    
    return ( 
        
            <div  >
                
              
                <Layout title="Store" description="This is the Store page"  >
                <ProductsGrid  />
                
                <div className="containerd">
                <div className="col-md-12 text-center" >
                    <Link to='/cart'><button type="submit" className="btn btn-info" style={{fontSize:"1.2em", marginTop: "40px", }}>Visualiser mon panier</button></Link>
                    </div>
                    </div>
                </Layout>
                
                
            </div>
      
     );
}


 
export default Store;